import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import OpenResidentialRegistry from './page/OpenResidentialRegistry';
import ResidentialRegistry from './page/ResidentialRegistry';
import Mapstat from "./page/Mapstat";
import UserStore from './stores/UserStore';
import * as vgAuth from './vgAuth';

function buildServicesFromRoles(roles = []) {
    const has = (name) => Array.isArray(roles) && roles.includes(name);

    const canBostadsregistret = has('API_SERVICE2:BOSTADSREGISTRET');
    const canMapstat          = has('MAPSTAT2:BASIC');

    return [
        { name:'Bostadsregistret', url: canBostadsregistret ? '/bostadsregistret' : '/', icon:'icon-home', target:'_self', active:true },
        canMapstat          && { name:'Mapstat',          url:'/mapstat',         icon:'icon-map',         target:'_self', active:true },
    ].filter(Boolean);
}

function hydrateFromSession() {
    try {
        const raw = sessionStorage.getItem('loginSession');
        if (!raw) return false;
        const s = JSON.parse(raw);

        UserStore.isLoggedIn    = !!s.isLoggedIn;
        UserStore.username      = s.username || '';
        UserStore.access_token  = s.access_token || '';
        UserStore.refresh_token = s.refresh_token || '';
        UserStore.roles         = Array.isArray(s.roles) ? s.roles : [];
        UserStore.picture       = s.picture || UserStore.picture;

        UserStore.services = buildServicesFromRoles(UserStore.roles);
        return true;
    } catch {
        return false;
    }
}

class App extends Component {
    async componentDidMount() {
        // Initialize VG auth
        vgAuth.initializeAuth();
        
        // Hydrate from session
        hydrateFromSession();

        try {
            // Check if we have authentication
            if (!vgAuth.isAuthenticated()) {
                return;
            }

            // Get access token and fetch user profile
            const accessToken = await UserStore.getAccessToken();
            const apiUrl = process.env.REACT_APP_API_URL || 'https://api-prod.valueguard.se';

            const meRes = await fetch(
                `${apiUrl}/v0/users/me?access_token=${encodeURIComponent(accessToken)}`,
                { headers: { Accept: 'application/json' } }
            );
            
            if (!meRes.ok) {
                console.error(`/v0/users/me failed: ${meRes.status}`);
                if (meRes.status === 401) {
                    UserStore.clear();
                }
                return;
            }
            
            const me = await meRes.json();

            // Update UserStore with profile data
            UserStore.setProfileFromMe(me);
            UserStore.setTokens({ accessToken });
            UserStore.services = buildServicesFromRoles(me.roles || []);
            UserStore.saveToSession();

        } catch (e) {
            console.error('App init failed:', e);
            UserStore.clear();
        }
    }

    render() {
        return (
            <BrowserRouter>
                <div>
                    <Route exact path='/' component={OpenResidentialRegistry} />
                    <Route exact path='/bostadsregistret' component={ResidentialRegistry} />
                    <Route exact path='/mapstat' component={Mapstat} />
                </div>
            </BrowserRouter>
        );
    }
}

export default App;